import React from "react";
import { LeafIcon } from "lucide-react";
const technologies = [{
  name: "Ondes de choc focales",
  text: "Une énergie précise, délivrée en profondeur, pour traiter tendinites et douleurs chroniques."
}, {
  name: "Hydrojet",
  text: "Un massage par l'eau, habillé et sans contact, pour relâcher les tensions musculaires."
}, {
  name: "Stendo",
  text: "Une stimulation pulsée de la circulation sanguine et lymphatique, synchronisée au rythme cardiaque."
}];
export function ApproachSection() {
  return <section className="bg-surface" data-id="element-160" data-mp="sfk41q4303a">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 py-20 md:px-8 md:py-24 lg:grid-cols-2 lg:gap-16" data-id="element-161" data-mp="3i7m9p84nmy4j">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/df39a82b-1698-4f91-8513-d197eb2bcdd7.jpg" alt="Application d'ondes de choc focales sur le talon d'un patient" className="aspect-[4/3] w-full rounded-3xl object-cover" data-id="element-162" data-mp="3n5w8rtti2ivf" />

        <div data-id="element-163" data-mp="6xijxqkxyhuq">
          <h2 className="text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-164" data-mp="6wzbr1l3f7tw">
            Des technologies de pointe, au service de soins responsables.
          </h2>
          <dl className="mt-8 space-y-5" data-id="element-165" data-mp="gvy8blsl3d0j">
            {technologies.map(tech => <div key={tech.name} className="grid gap-1 sm:grid-cols-[180px_1fr] sm:gap-6" data-id="element-166" data-mp="gtltvim1bks8">
                <dt className="text-sm font-semibold text-ink" data-id="element-167" data-mp="busjw05yibwt">{tech.name}</dt>
                <dd className="text-sm leading-relaxed text-muted" data-id="element-168" data-mp="3kd6swdep4qyy">{tech.text}</dd>
              </div>)}
          </dl>

          <div className="mt-10 flex gap-4 rounded-2xl bg-white p-6" data-id="element-169" data-mp="3u2hvriazozee">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-success/10 text-success" data-id="element-170" data-mp="3u3sz5h0iw54z">
              <LeafIcon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="3p9x86yiofijb" />
            </span>
            <div data-id="element-172" data-mp="31k2u6dmmfnxh">
              <p className="text-sm font-semibold text-ink" data-id="element-173" data-mp="2wn41lzilvp1e">Engagé EcoSoignant</p>
              <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-174" data-mp="2wkzy3iomcs1n">
                Matériel durable, réduction des déchets, sobriété énergétique : des soins pensés pour vous et
                pour la planète.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}